import type { FormItemRule } from 'element-plus'

export const positiveNumberRule: FormItemRule = {
  validator: (_, value: string, callback: (e?: Error) => void) => {
    if (!value) {
      return callback()
    }

    const formattedValue = Number(value)
    if (isNaN(formattedValue)) {
      return callback(new Error('Field must be a valid number'))
    }
    if (formattedValue < 0) {
      return callback(new Error('Field must be a positive number'))
    }

    return callback()
  },
  trigger: 'blur',
}

export const positiveAmountRule: FormItemRule = {
  type: 'number',
  min: 0,
  message: 'Value must be equal or greater than 0',
  trigger: 'blur',
}
export const maxAmountRule: FormItemRule = {
  type: 'number',
  max: 10000000,
  message: 'Value must be less than 10000000',
  trigger: 'blur',
}

export const requiredRule: FormItemRule = {
  required: true,
  message: 'This field is required',
  trigger: 'blur',
}

export const maxLengthRule: FormItemRule = {
  max: 255,
  message: 'Field must be shorter than 255 symbols',
  trigger: 'blur',
}
